// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__77299","dismiss":"styles_dismiss__j_fmA"};